export default {"src":"/_next/static/media/snackbar_gift.f13934c2.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};